// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alternative-group .alternative[data-v-2139f38f]  .v-icon.alt-icon{height:24px;width:24px}.alternative-group .alternative[data-v-2139f38f]  .v-icon.alt-icon svg path{fill:var(--v-gray-dark)}", ""]);
// Exports
module.exports = exports;
